import { useEffect, useRef } from 'react';
import { useApiContext } from 'react-easyrocket';
import { useModalContext } from '../../../hooks/useModalContext';

type onSuccessType = () => void;

export const useAuthFlowSuccessCallback = () => {
  const { openedModalName, modalProps } = useModalContext<{
    onAuthFlowSuccess: onSuccessType;
  }>();
  const onSuccessRef = useRef<onSuccessType | null>(null);
  const { isAuthenticated } = useApiContext();

  useEffect(() => {
    if (
      !isAuthenticated &&
      (openedModalName === 'SIGNUP' || openedModalName === 'LOGIN') &&
      typeof modalProps?.onAuthFlowSuccess === 'function'
    ) {
      onSuccessRef.current = modalProps.onAuthFlowSuccess;
    }
    if (
      isAuthenticated &&
      openedModalName !== 'SIGNUP' &&
      openedModalName !== 'LOGIN' &&
      onSuccessRef.current
    ) {
      onSuccessRef.current();
      onSuccessRef.current = null;
    }
  }, [openedModalName]);
};
